// contexts/CampaignContext.ts
import { createContext, useContext } from 'react';

// The value shape mirrors what useCampaignData() returns.
// Will be tightened once the hooks layer is converted to TypeScript.
export interface CampaignContextValue {
    customerData: unknown[];
    customerContent: Record<string, unknown>;
    selectedCustomerId: number | null;
    loading: boolean;
    hasLoadedOnce: boolean;
    setSelectedCustomerId: (customerId: number) => void;
    handleSave: (data: Record<string, unknown>, isValid: boolean, modalType: string) => Promise<void>;
    handleSaveCampaign: (data: Record<string, unknown>, isValid: boolean, modalType: string) => Promise<void>;
    handleSaveBooking: (data: Record<string, unknown>, isValid: boolean, modalType: string) => Promise<void>;
    handleSaveCreative: (data: Record<string, unknown>, isValid: boolean, modalType: string) => Promise<void>;
    handleSaveImpressionTag: (data: Record<string, unknown>, isValid: boolean, modalType: string) => Promise<void>;
    handleSaveSiteTag: (data: Record<string, unknown>, isValid: boolean, modalType: string) => Promise<void>;
    refreshData: () => void;
    refreshCustomers: () => void;
}

export const CampaignContext = createContext<CampaignContextValue | null>(null);

export const useCampaign = (): CampaignContextValue => {
    const context = useContext(CampaignContext);

    if (context === null) {
        throw new Error('useCampaign must be used within a CampaignProvider');
    }

    return context;
};

// NOTE: The localStorage synchronisation that was previously in this hook
// belongs in CampaignProvider (or useCampaignData), not here.
// Consumer hooks should be pure context accessors - no side effects.
